import { AVATAR_INFO } from '../constants/avatars'

/**
 * Handles avatar selection for a player.
 *
 * @param {Object} params
 * @param {string} params.playerId - ID of the player to update
 * @param {string|null} params.filename - Avatar filename or null for deselection
 * @param {Array} params.players - Current players array (for validation)
 * @param {Function} params.setPlayers - State setter for players
 * @param {Function} params.setSelectingAvatarFor - State setter to close selector
 */
export function handleAvatarSelect ({
  playerId,
  filename,
  players,
  setPlayers,
  setSelectingAvatarFor
}) {
  // Validate playerId exists in current players
  const playerExists = players.some(player => player.id === playerId)

  if (!playerExists) {
    if (import.meta.env.MODE === 'development') {
      console.warn(`[handleAvatarSelect] Player with ID ${playerId} not found`)
    }
    setSelectingAvatarFor(null)
    return
  }

  // Validate filename is in allowed avatars or null (deselection)
  const isValidAvatar = filename === null ||
    AVATAR_INFO.some(avatar => avatar.filename === filename)

  if (!isValidAvatar) {
    if (import.meta.env.MODE === 'development') {
      console.warn('[handleAvatarSelect] Invalid avatar filename:', filename)
    }
    setSelectingAvatarFor(null)
    return
  }

  // All validations passed - proceed with assignment
  setPlayers(prev =>
    prev.map(player =>
      player.id === playerId
        ? { ...player, avatar: filename }
        : player
    )
  )
  setSelectingAvatarFor(null)
}
